/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });

  // Read More / Read Less toggle for collection descriptions
  function initReadMore() {
    document.querySelectorAll('element-text-rte.rte--collection-desc').forEach(function(el) {

      if (el.dataset.readMoreInit) return;
      el.dataset.readMoreInit = 'true';

      // Remove any stray buttons that may have been injected before init
      el.querySelectorAll('.read-more-btn').forEach(function(b) { b.remove(); });
      var sibling = el.nextElementSibling;
      while (sibling && sibling.classList.contains('read-more-btn')) {
        var next = sibling.nextElementSibling;
        sibling.remove();
        sibling = next;
      }

      const paragraphs = Array.from(el.querySelectorAll('p')).filter(function(p) {
        return p.innerText.trim().length > 0;
      });

      if (paragraphs.length <= 1) return;

      const firstP = paragraphs[0];
      const hasLinks = firstP.querySelectorAll('a').length > 0;

      if (!hasLinks) {
        const plainText = firstP.innerText.trim();
        const sentences = plainText.match(/[^.!?]+[.!?]+/g) || [];
        if (sentences.length > 1) {
          const firstSentence = sentences[0];
          const restOfText = sentences.slice(1).join(' ');
          firstP.innerHTML = firstSentence + '<span class="clamp-hidden"> ' + restOfText + '</span>';
        }
      }

      paragraphs.slice(1).forEach(function(p) {
        p.classList.add('clamp-hidden');
      });

      const children = Array.from(el.children);
      children.slice(2).forEach(function(child) {
        child.classList.add('clamp-hidden');
      });

      const btn = document.createElement('button');
      btn.classList.add('read-more-btn');
      btn.textContent = 'Read More';

      btn.addEventListener('click', function() {
        el.classList.toggle('expanded');
        const isExpanded = el.classList.contains('expanded');
        btn.textContent = isExpanded ? 'Read Less' : 'Read More';
        if (isExpanded) {
          el.after(btn);
        } else {
          firstP.after(btn);
        }
      });

      firstP.after(btn);
    });
  }

  // Use setTimeout only as fallback — page:loaded is the primary trigger
  document.addEventListener('page:loaded', initReadMore);
  setTimeout(initReadMore, 1500);

})();